export default __webpack_public_path__ + "static/media/tribar.41e4fc0f.svg";